export default {
    currentMergeAction: '',
    mergeManualCheckDuplicate: false,
    communicatingLeads: [],
    hideSensitiveInfoMode: false,
    phoneIsEnabled: false,
    emailIsEnabled: false,
    smsIsEnabled: false,
};
